import script from "./ContentListItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentListItemDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__